import { withState } from 'recompose';

export default withState('anchorEl', 'setAnchorEl', false);
